/* KS relaunch guide — 出站點擊追蹤（/pages/ks-relaunch）
 *
 * 這一頁的驗收指標是「出站點擊率」：進來的人有沒有真的點出去進到 collection。
 * 沒有這支就沒辦法驗收，所以它跟頁面是同一組東西。
 *
 * 三個 sink，各自 optional、永遠不 throw（同 ks-nav-tracking.js 的作法）：
 *   1. Shopify.analytics.publish → GA4 custom pixel（要把 ks_relaunch_click
 *      加進 pixel 的 event list，否則收不到）
 *   2. window.clarity
 *   3. window.dataLayer
 *
 * Params:
 *   ks_r_slot  — search / chip / zone / stuck / cta
 *   ks_r_label — 連結文字（去頭尾空白，最多 80 字）
 *   ks_r_url   — pathname（站內連結才送）
 */
(function () {
  if (window.__ksRelaunchTracking) return;
  window.__ksRelaunchTracking = true;

  function track(name, params) {
    var payload = params || {};
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (_e) { /* 追蹤絕不能擋住導航 */ }
    try {
      if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (_e) { /* noop */ }
    try {
      window.dataLayer = window.dataLayer || [];
      var entry = { event: name };
      for (var k in payload) entry[k] = payload[k];
      window.dataLayer.push(entry);
    } catch (_e) { /* noop */ }
  }

  function label(el) {
    var t = (el.getAttribute('data-ksr-label') || el.textContent || '').replace(/\s+/g, ' ').trim();
    return t.length > 80 ? t.slice(0, 80) : t;
  }

  document.addEventListener('click', function (event) {
    try {
      var target = event.target;
      if (!target || !target.closest) return;
      var el = target.closest('[data-ksr-slot]');
      if (!el) return;

      var params = {
        ks_r_slot: el.getAttribute('data-ksr-slot'),
        ks_r_label: label(el)
      };
      var href = el.getAttribute('href');
      if (href && href.charAt(0) === '/') params.ks_r_url = href.split('?')[0];
      track('ks_relaunch_click', params);
    } catch (_e) { /* noop */ }
  }, true);

  // 送出搜尋也算一次出站
  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[data-ksr-slot="search"]')) return;
      var input = form.querySelector('input[name="q"]');
      track('ks_relaunch_click', {
        ks_r_slot: 'search',
        ks_r_label: input && input.value ? input.value.slice(0, 80) : '(empty)'
      });
    } catch (_e) { /* noop */ }
  }, true);
})();
